import { useState, useEffect } from "react";
import styles from './messages.module.css';
import { Link } from "react-router-dom";
import {API_URL} from '../../trip/utils/fatch';

export const MessagesManagement = () => {


    const [messages, setMessages] = useState([]);

    
    /*    const fakeUser = [
   
           {
               created_at: "2025-08-18T19:25:28.000Z",
               current_trip_id: 20,
               email: "2048yossi@gmail.com",
               email_verified: false,
               firstname: "joseph",
               id: 31,
               is_active: true,
               last_login: null,
               lastname: "goldberger",
               role: "user",
               token_expires_at: null,
               updated_at: "2025-08-18T19:25:28.000Z",
               verification_token: null
           }
   
       ] */






    async function fetchAndRenderAllData() {


        try {


            const response = await fetch(`${API_URL}/admin/allMessages`,
                {
                    method: 'GET', // Use 'POST' for login
                    credentials: 'include', // ✅ Required for cookies

                }
            );
            // console.log(budgetResponse.status);
            if (!response.ok) {
                console.log(response.status);

                return

            }
            const data = await response.json();
            console.log(data);

            setMessages(data.messages);




        } catch (error) {
            console.error("Error fetching data:", error);


        }
    }

    useEffect(() => {
        fetchAndRenderAllData();
    }, [])
    return (<>

       
        <main className={styles.main}>
            <div className={styles.pageHeader}>
                <Link to="/admin" className={styles.adminLink}>Go Back</Link>

                <h2 className={styles.h2}>Messages Management</h2>
                <div className={styles.adminLink} style={{ visibility: 'hidden' }}></div>

            </div>



            <table className={styles.userTable}>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Status</th>
                        <th>Name</th>
                        <th>Message</th>
                        <th>user_id</th>
                        <th>email</th>
                        <th>Date</th>

                    </tr>
                </thead>
                <tbody>
                    {messages.map((message) => (
                        <tr key={message.id}>
                            <td>{message.id}</td>
                            <td>{message.status}</td>
                            <td>{message.sender}</td>
                            <td>{message.message}</td>
                            <td>{message.user_id}</td>
                            <td>{message.email}</td>


                            <td>{message.timestamp}</td>
                        </tr>
                    ))}
                </tbody>
            </table>


        </main>

    </>)
}